import { BehaviorSubject, Observable } from 'rxjs';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { ExecutionAudit, ExecutionAuditFilter, ExecutionQAuditFilter } from './execution';
import { catchError, finalize } from 'rxjs/operators';


import { of } from 'rxjs';
import { ExecutionQService } from '../services/executionQ.service';

export class ExecutionQAuditDataSource implements DataSource<ExecutionAudit> {

    private executionsSubject = new BehaviorSubject<ExecutionAudit[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private totalSubject = new BehaviorSubject<number>(0);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public loading$ = this.loadingSubject.asObservable();
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public totalItems$ = this.totalSubject.asObservable();

   

    constructor(private service: ExecutionQService) { }

    connect(_collectionViewer: CollectionViewer): Observable<ExecutionAudit[]> {
        return this.executionsSubject.asObservable();
    }

    disconnect(_collectionViewer: CollectionViewer): void {
        this.executionsSubject.complete();
        this.loadingSubject.complete();
        this.totalSubject.complete();
    }

    loadExecutionAudit(id: number, filter = new ExecutionQAuditFilter()): void {

        this.loadingSubject.next(true);
        
        this.service.getAudit(id, filter).pipe(
            catchError(() => of([])),
            finalize(() => this.loadingSubject.next(false))
        ).subscribe(data => {
            if (data && data.content) {
                this.executionsSubject.next(data.content as ExecutionAudit[]);
                this.totalSubject.next(data.totalElements as number);
            } else if (data) {
                this.executionsSubject.next(data as ExecutionAudit[]);
                this.totalSubject.next(data.length as number);
            } else {
                this.executionsSubject.next([]);
                this.totalSubject.next(0);
            }
        });
    }
}
